import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { searchBox, hits, hitsPerPage, stats, refinementList, menu, clearRefinements, currentRefinements, toggleRefinement, numericMenu } from 'instantsearch.js/es/widgets';
import { connectSortBy, connectPagination } from 'instantsearch.js/es/connectors';

let firstLoad = true;

const selectedCategoryDiv = document.getElementById('selected-category-shop');
const selectedAgeDiv = document.getElementById('selected-age-shop');
const selectedTypeDiv = document.getElementById('selected-type-shop');
const selectedPriceDiv = document.getElementById('selected-price-shop');
const searchContainer = document.querySelector('.shop-filter-section');

const searchClient = algoliasearch(window.algoliaAppId, window.algoliaApiKey);

const hasCmsDefaultFilters = [defaultFilters.category, defaultFilters.type, defaultFilters.age, defaultFilters.price]
	.some((v) => v && v !== '');

const search = instantsearch({
	indexName: window.algoliaIndexShop,
	searchClient,
	routing: true,
    initialUiState: {
        [window.algoliaIndexShop]: {
            menu: {
                category: defaultFilters.category,
                age: defaultFilters.age,
                type: defaultFilters.type,
            },
            numericMenu: {
                price: defaultFilters.price,
            },
        },
    },
	searchFunction(helper) {
		var ageFilterUsed = helper.state.hierarchicalFacetsRefinements.age.length ? helper.state.hierarchicalFacetsRefinements.age[0] !== defaultFilters.age : false;
		var categoryFilterUsed = helper.state.hierarchicalFacetsRefinements.category.length ? helper.state.hierarchicalFacetsRefinements.category[0] !== defaultFilters.category : false;
		var typeFilterUsed = helper.state.hierarchicalFacetsRefinements.type.length ? helper.state.hierarchicalFacetsRefinements.type[0] !== defaultFilters.type : false;
		var priceFilterUsed = jQuery.isEmptyObject(helper.state.numericRefinements.price) === false;
		var queryFilterUsed = helper.state.query.length > 0;
		var sortFilterUsed = helper.state.index !== window.algoliaIndexShop;
		var pageFilterUsed = helper.state.page !== 0;
		var filterUsed = ageFilterUsed || categoryFilterUsed || typeFilterUsed || priceFilterUsed || queryFilterUsed || sortFilterUsed || pageFilterUsed;

		if (firstLoad && !filterUsed && !hasCmsDefaultFilters) {
			console.log('%c[Shop] Skipping Algolia — showing server-rendered cache (default filters match page defaults)', 'color: #22c55e; font-weight: bold;');
			$('.ais-Hits-Cached').show();
			$('.ais-Stats-Cached').show();
			$('.ais-Pagination-Cached').show();
			checkStockForPage();
			return false;
		}
		console.log('%c[Shop] Firing Algolia search', 'color: #f59e0b; font-weight: bold;', {
			firstLoad,
			filterUsed,
			active: { ageFilterUsed, categoryFilterUsed, typeFilterUsed, priceFilterUsed, queryFilterUsed, sortFilterUsed, pageFilterUsed }
		});
		helper.search();

	},
	onStateChange({ uiState, setUiState }) {
		// Custom logic
		console.log('uiStateVar')
		console.log(uiStateVar)
		firstLoad = false;
		var uiStateVar = uiState[window.algoliaIndexShop];
		if (uiStateVar.menu !== undefined) {
			const selectedCategory = uiStateVar.menu.category;
			if (selectedCategory !== undefined) {
				selectedCategoryDiv.textContent = selectedCategory;
			}
			const selectedAge = uiStateVar.menu.age;
			if (selectedAge !== undefined) {
				selectedAgeDiv.textContent = selectedAge;
			}
			const selectedType = uiStateVar.menu.type;
			if (selectedType !== undefined) {
				selectedTypeDiv.textContent = selectedType;
			}
		} else {
			selectedCategoryDiv.textContent = 'All';
			selectedAgeDiv.textContent = 'All';
		}
		if (uiStateVar.numericMenu !== undefined) {
			const selectedPrice = uiStateVar.numericMenu.price;
			console.log('selectedPrice ' + selectedPrice)
			if (selectedPrice !== undefined) {
				selectedPriceDiv.textContent = selectedPrice;
			}
		} else {
			selectedPriceDiv.textContent = 'All';
		}
		$('.categories-dropdown.open').removeClass('open');
		$('.age-dropdown.open').removeClass('open');
		$('.type-dropdown.open').removeClass('open');
		$('.price-dropdown.open').removeClass('open');
		setUiState(uiState);
	},
});

// Custom render function for sortBy
const renderSortBy = (renderOptions, isFirstRender) => {
    const { refine, widgetParams } = renderOptions;

	const currentRefinement = renderOptions.currentRefinement;

    const handleClick = (value) => {
        refine(value);
    };

    const container = document.querySelector(widgetParams.container);
    container.innerHTML = `
            <button data-value="${window.algoliaIndexShop}" class="sort-item ${currentRefinement == window.algoliaIndexShop ? 'active' : ''}">
				<span class="title">Featured first</span>
				<span class="indicator"></span>
            </button>
            <button data-value="${window.algoliaIndexShop + '_dateUpdated_desc'}" class="sort-item ${currentRefinement == window.algoliaIndexShop + '_dateUpdated_desc' ? 'active' : ''}">
				<span class="title">Most recent first</span>
				<span class="indicator"></span>
            </button>
            <button data-value="${window.algoliaIndexShop + '_dateUpdated_asc'}" class="sort-item ${currentRefinement == window.algoliaIndexShop + '_dateUpdated_asc' ? 'active' : ''}">
				<span class="title">Oldest first</span>
				<span class="indicator"></span>
            </button>
    `;

    const sortButtons = container.querySelectorAll('.sort-item');
    sortButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const value = button.getAttribute('data-value');
            handleClick(value);
        });
    });

	var activeBtn = container.querySelector('.sort-item.active');
	var activeBtnText = activeBtn.querySelector('.title').textContent;
	const titleElement = document.querySelector('.sort-dropdown .btn-sort strong');
	titleElement.textContent = activeBtnText;
};

// Create custom sortBy widget using connectSortBy
const customSortBy = connectSortBy(renderSortBy);

// Custom pagination widget — same ellipsis algorithm as /lessons portal page
const renderPagination = (renderOptions) => {
    const { currentRefinement, nbPages, refine } = renderOptions;
    const container = document.getElementById('pagination-shop');
    if (!container) return;

    if (nbPages === 0) return; // no search yet — leave cached Twig pagination intact
    if (nbPages === 1) {
        container.innerHTML = '';
        return;
    }

    const current = currentRefinement;
    const last = nbPages - 1;

    // Build visible page set (always include first, last, and neighbours of current)
    const minVisible = Math.min(5, nbPages);
    const pageSet = new Set([0, last, current - 1, current, current + 1]);
    let radius = 2;
    while (pageSet.size < minVisible) {
        const l = current - radius;
        const r = current + radius;
        if (l >= 0) pageSet.add(l);
        if (r <= last) pageSet.add(r);
        if (l < 0 && r > last) break;
        radius++;
    }

    const sorted = [...pageSet].filter(p => p >= 0 && p <= last).sort((a, b) => a - b);
    const tokens = [];
    let prev = null;
    for (const p of sorted) {
        if (prev != null && p - prev > 1) tokens.push({ type: 'ellipsis' });
        tokens.push({ type: 'page', page: p });
        prev = p;
    }

    const btnClass = 'shop-pagination-btn';
    const pageClass = 'shop-pagination-page';
    const ellipsisClass = 'shop-pagination-ellipsis';

    let html = '<div class="shop-pagination-inner">';

    html += `<button class="${btnClass}" ${current <= 0 ? 'disabled' : ''}>‹</button>`;

    for (const token of tokens) {
        if (token.type === 'ellipsis') {
            html += `<span class="${ellipsisClass}">…</span>`;
        } else {
            const isActive = token.page === current;
            html += `<button class="${pageClass}${isActive ? ' active' : ''}" data-p="${token.page}">${token.page + 1}</button>`;
        }
    }

    html += `<button class="${btnClass}" ${current >= last ? 'disabled' : ''}>›</button>`;
    html += '</div>';

    container.innerHTML = html;

    const shopEl = document.getElementById('shop');
    const scrollToShop = () => { if (shopEl) shopEl.scrollIntoView({ behavior: 'smooth' }); };

    const navBtns = container.querySelectorAll(`.${btnClass}`);
    navBtns[0].addEventListener('click', () => { if (current > 0) { refine(current - 1); scrollToShop(); } });
    navBtns[navBtns.length - 1].addEventListener('click', () => { if (current < last) { refine(current + 1); scrollToShop(); } });

    container.querySelectorAll('[data-p]').forEach(btn => {
        btn.addEventListener('click', () => {
            refine(parseInt(btn.dataset.p));
            scrollToShop();
        });
    });
};

const customPagination = connectPagination(renderPagination);





search.addWidgets([

    searchBox({
        container: '#searchbox-shop',
		placeholder: 'Start typing to search',
		clear: false,
		queryHook(query, search) {
			search(query);
		},
		templates: {

		},
    }),

	hitsPerPage({
		container: '#hits-per-page-shop',
		items: [
			{ label: '16 hits per page', value: 16, default: true },
		],
	}),

	stats({
		container: '#stats-shop',
		templates: {
			text(data, { html }) {
				return "<span class='desktop-only'>We've found&nbsp;</span><strong>" + data.nbHits + "</strong>" + (data.nbHits == 1 ? ' product' : ' products');
			},
		},
	}),

    hits({
		container: '#hits-shop',
		templates: {
			item(hit, { html, components, sendEvent }) {
				// If a custom template URL is needed (e.g., for a specific product)
				return hit.html;
			},
		},
    }),

	customPagination({}),

    customSortBy({
        container: '#sort-by-shop', // Specify the container element
        items: [ // Define sorting options
            { label: 'Featured', value: window.algoliaIndexShop },
            { label: 'Most recent', value: window.algoliaIndexShop + '_dateUpdated_desc' },
            { label: 'Oldest', value: window.algoliaIndexShop + '_dateUpdated_asc' }
        ]
    }),

	menu({
		container: '#menu-shop-category',
		attribute: 'category',
		sortBy: ['name:asc'],
		templates: {
			item(item, { html }) {
				const { url, label, count, isRefined } = item;
	
				return html`
					<a href="${url}" class="${isRefined ? 'active' : ''}">
						<span class="title">${label}</span>
						<span class="indicator"></span>
					</a>
				`;
			},
		},
		// Define how to handle clicks on the "ALL" option
		transformItems(items) {
			return [{ label: 'Discipline: All', value: '', isRefined: items.every(item => !item.isRefined) }, ...items];
		}
	}),

	menu({
		container: '#menu-shop-age',
		attribute: 'age',
		sortBy: ['name:asc'],
		templates: {
			item(item, { html }) {
				const { url, label, count, isRefined } = item;
	
				return html`
					<a href="${url}" class="${isRefined ? 'active' : ''}">
						<span class="title">${label}</span>
						<span class="indicator"></span>
					</a>
				`;
			},
		},
		// Define how to handle clicks on the "ALL" option
		transformItems(items) {
			return [{ label: 'Age: All', value: '', isRefined: items.every(item => !item.isRefined) }, ...items];
		}
	}),

	menu({
		container: '#menu-shop-type',
		attribute: 'type',
		sortBy: ['name:asc'],
		templates: {
			item(item, { html }) {
				const { url, label, count, isRefined } = item;
	
				return html`
					<a href="${url}" class="${isRefined ? 'active' : ''}">
						<span class="title">${label}</span>
						<span class="indicator"></span>
					</a>
				`;
			},
		},
		// Define how to handle clicks on the "ALL" option
		transformItems(items) {
			return [{ label: 'Type: All', value: '', isRefined: items.every(item => !item.isRefined) }, ...items];
		}
	}),

	numericMenu({
		container: '#menu-shop-price',
		attribute: 'price',
		items: [
			{ label: 'Price: All' },
			{ label: 'Under $20', end: 20 },
			{ label: 'Under $30', end: 30 },
			{ label: 'Under $50', end: 50 },
			{ label: 'Under $100', end: 100 },
		],
		templates: {
			item(item, { html }) {
				const { url, label, count, isRefined } = item;
	
				return html`
					<a href="${url}" class="${isRefined ? 'active' : ''}">
						<span class="title">${label}</span>
						<span class="indicator"></span>
					</a>
				`;
			},
		},
		// Define how to handle clicks on the "ALL" option
		// transformItems(items) {
		// 	return [{ label: 'Price: All', isRefined: items.every(item => !item.isRefined) }, ...items];
		// }
	}),

	currentRefinements({
		container: '#current-refinements-shop',
		excludedAttributes: [],
	}),

	clearRefinements({
		container: '#clear-refinements-shop',
		templates: {
			resetLabel({ hasRefinements }, { html }) {
				return html`<span>${hasRefinements ? 'Clear filters' : ''}</span>`;
			},
		},
	}),
  
  

]);






search.start();

var isFirstRender = true;

search.on('render', function() {
	var renderStateVar = search.renderState[window.algoliaIndexShop];
	console.log(renderStateVar)
	// console.log('search.status ' + search.status);
	if (renderStateVar.menu !== undefined) {
		const categories = renderStateVar.menu.category.items;
		const refine = categories.filter(item => item.isRefined === true);
		const selectedCategory = refine.find(item => item.isRefined === true);
		if (selectedCategory !== undefined) {
			selectedCategoryDiv.textContent = selectedCategory.label;
		}
		const age = renderStateVar.menu.age.items;
		const refineAge = age.filter(item => item.isRefined === true);
		const selectedAge = refineAge.find(item => item.isRefined === true);
		if (selectedAge !== undefined) {
			selectedAgeDiv.textContent = selectedAge.label;
		}
		const type = renderStateVar.menu.type.items;
		const refineType = type.filter(item => item.isRefined === true);
		const selectedType = refineType.find(item => item.isRefined === true);
		if (selectedType !== undefined) {
			selectedTypeDiv.textContent = selectedType.label;
		}
		const price = renderStateVar.numericMenu.price.items;
		const refinePrice = price.filter(item => item.isRefined === true);
		const selectedPrice = refinePrice.find(item => item.isRefined === true);
		if (selectedPrice !== undefined) {
			selectedPriceDiv.textContent = selectedPrice.label;
		}

	} else {
		selectedCategoryDiv.textContent = 'All';
		selectedAgeDiv.textContent = 'All';
		selectedTypeDiv.textContent = 'Type';
		selectedPriceDiv.textContent = 'Price';
	}


	checkStockForPage();

	resizeVideo();
	
});



$(document).on('click', '.filter-dropdown', function(e) {
	console.log('filter-dropdown')
	var dropdowns = $('.filter-dropdown');
	dropdowns.removeClass('open');
	var el = $(this);
	el.addClass('open');
});

$(document).on('click', '.filter-dropdown.open', function(e) {
	console.log('filter-dropdown')
	var dropdowns = $('.filter-dropdown');
	dropdowns.removeClass('open');
	var el = $(this);
	el.removeClass('open');
});

$(document).on('click', function(e) {
    var dropdown = $('.filter-dropdown');
    // Check if the click event originated from inside the dropdown
    if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
        dropdown.removeClass('open');
    }
});

$(document).on('click', '#menu-shop-category a', function(e) {
	e.preventDefault();
	var title = $(this).find('.title').text();
	search.setUiState({
		[window.algoliaIndexShop]: {
			menu: {
				category: title
			}
		}
	});
});
$(document).on('click', '#menu-shop-age a', function(e) {
	e.preventDefault();
	var title = $(this).find('.title').text();
	search.setUiState({
		[window.algoliaIndexShop]: {
			menu: {
				age: title
			}
		}
	});
});
$(document).on('click', '#menu-shop-type a', function(e) {
	e.preventDefault();
	var title = $(this).find('.title').text();
	search.setUiState({
		[window.algoliaIndexShop]: {
			menu: {
				type: title
			}
		}
	});
});
$(document).on('click', '#menu-shop-price a', function(e) {
	e.preventDefault();
	var priceValue = $(this).data('price-end');
	search.setUiState({
		[window.algoliaIndexShop]: {
			numericMenu: {
				price: 'end:' + priceValue
			}
		}
	});
});
$(document).on('click', '#pagination-shop [data-page]', function(e) {
	e.preventDefault();
	var page = parseInt($(this).data('page'));
	search.setUiState({
		[window.algoliaIndexShop]: {
			page: page
		}
	});
	var shopEl = document.getElementById('shop');
	if (shopEl) shopEl.scrollIntoView({ behavior: 'smooth' });
});





///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SORT DROPDOWN

$('.sort-dropdown .btn').on("click", function(e) {
    e.stopPropagation();
    $('.sort-dropdown .btn').toggleClass('open');
    if ($('.sort-dropdown .btn').hasClass('open')) {
        // $('.menu-user .btn span').html('Close');
    } else {
        // $('.menu-user .btn span').html('Menu');
    }
});
$(document).on("click", function(e) {
    $('.sort-dropdown .btn').removeClass('open');
    // $('.menu-user .btn span').html('Menu');
});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////